import React, { useState } from 'react';
import { LatLngTuple, LeafletMouseEvent, LatLng } from 'leaflet';
import { LayersControl, Map, Marker, TileLayer, Polyline } from 'react-leaflet';

const { BaseLayer } = LayersControl;
interface IMarker {
  point?: LatLngTuple;
  drawPoint?: LatLng;
  onClick?: (event: LeafletMouseEvent) => void;
  notDragabble?: boolean;
  interventionType?: string;
  location?: Array<LatLng>;
  setLocation?: React.Dispatch<React.SetStateAction<Array<LatLng>>>;
}

const center = new LatLng(-3.8046721, -38.5697856);

const MapMarker: React.FC<IMarker> = ({
  point,
  drawPoint,
  onClick,
  notDragabble,
  interventionType,
  location,
  setLocation,
}) => {
  const [zoom, setZoom] = useState<number>(12);

  const renderMarker = () => {
    if (point && point[0] && point[1] !== 0) {
      return (
        <Marker
          draggable={!notDragabble}
          ondragend={(e) =>
            alert('Clique no marcador para a mudança de lugar ser confirmada')
          }
          position={point}
        />
      );
    }
    if (drawPoint && drawPoint.lat && drawPoint.lng !== 0) {
      return (
        <Marker
          draggable={!notDragabble}
          ondragend={(e) =>
            alert('Clique no marcador para a mudança de lugar ser confirmada')
          }
          position={drawPoint}
        />
      );
    }
    return <></>;
  };

  const handleClick = (event: LeafletMouseEvent) => {
    if (setLocation) {
      if (interventionType === 'Linha') setLocation((state) => [...state, event.latlng]);
      else setLocation([event.latlng]);
    }
    if (onClick) onClick(event);
  };

  return (
    <Map
      center={center}
      length={0}
      zoom={zoom}
      {...(point && point[0] !== 0 ? { bounds: [point, [point[0], point[1]]] } : {})}
      {...(drawPoint && drawPoint.lat !== 0
        ? { bounds: [drawPoint, [drawPoint.lat, drawPoint.lng]] }
        : {})}
      {...(location && location.length
        ? { bounds: [location[0], [location[0].lat, location[0].lng]] }
        : {})}
      className="leaflet-marker"
      onclick={handleClick}
    >
      <LayersControl position="topright">
        <BaseLayer name="Satelite">
          <TileLayer
            zIndex={1}
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          />
        </BaseLayer>
        <BaseLayer checked name="Ruas">
          <TileLayer
            zIndex={1}
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          />
        </BaseLayer>
        <BaseLayer name="Dark">
          <TileLayer
            zIndex={1}
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          />
        </BaseLayer>
        <Polyline
          pathOptions={{ color: 'black' }}
          positions={location || [center]}
          draggable={!notDragabble}
        />
      </LayersControl>
      {renderMarker()}
    </Map>
  );
};
export default MapMarker;
